import React from "react";
import { Link } from "react-router-dom";
import { useCms } from "../../cms/CmsProvider";
import { getNewsList } from "../../cms/news";
import { NewsCard } from "../../pages/NewsPage";
import "../../assets/styles/news.css";

const NewsSection = () => {
    const { site, isJa } = useCms("site");
    const news = getNewsList(site).slice(0, 3);
    if (news.length === 0) return null; // お知らせが無いときは何も表示しない

    return (
        <section className="news-section news-section--cards">
            <h2 className="news-heading">{isJa ? "お知らせ" : "News"}</h2>
            <ul className="news-cards news-cards--compact">
                {news.map((n) => <NewsCard key={n.id} item={n} showExcerpt={false} />)}
            </ul>
            <div className="news-back">
                <Link to="/news">{isJa ? "お知らせ一覧へ" : "All news"}</Link>
            </div>
        </section>
    );
};

export default NewsSection;
